import _ from 'lodash';

import {BASENAME} from './Site'

export const concatRoutes = (...routes) => {
	return "/" + routes.map(val=>(val+"").replace(/^\/+|\/+$/g,"")).filter(route=>!!(route.trim())).join("/");
}

export const site_url = (url) => concatRoutes(BASENAME, url);

export function totalKeys(obj, obj2) {
	return [...new Set([...Object.keys(obj), ...Object.keys(obj2)])]
}

export const difference = (object2, base2, {missingVal=null}={})=> {
	function changes(obj, base) {
		return _.reduce(totalKeys(obj, base), (acc, key)=>{
			if (!_.isEqual(base[key], obj[key])) {
				acc[key] = (_.isObject(base[key]) && _.isObject(obj[key])) ? changes(obj[key], base[key]) : 
					(typeof obj[key]==="undefined" ? missingVal : obj[key]);
			}
			return acc;
		}, {});
	}
	return changes(object2, base2);
}

export const capitalWord = (val) => {
	return val.substr(0,1).toUpperCase() + val.substr(1).toLowerCase();
}

export const upperFirst = (val='') => {
	return val.substr(0,1).toUpperCase() + val.substr(1);
}

export const fechaFormat = (fecha, {separador='/'}={}) => {
	if (!fecha) return '';
	fecha = new Date(fecha);
	return [fecha.getDate(), fecha.getMonth()+1, fecha.getFullYear()].join(separador)
}

export const horaFormat = (fecha, {separador=':'}={}) => {
	if (!fecha) return '';
	fecha = new Date(fecha);
	return [fecha.getHours(), fecha.getMinutes()].join(separador)
}
